<template>
  <div
    class="robot-content"
    @click.self="robotShwo = false"
    :style="{ pointerEvents: !robotShwo ? 'none' : 'fill' }"
  >
    <transition name="Fade">
      <div
        :style="{
          width: robotWidth + screenX + 'px',
          top: '66px',
          left: left,
        }"
        class="robot-view"
        v-drag:{top:false,left:false,dragClass:null}="{
          top: true,
          left: true,
          dragClass: 'drag-box',
        }"
        v-show="robotShwo"
        ref="robotView"
      >
        <div class="title-bar drag-box">
          <div class="logo drag-box">
            <!-- <img src="../assets/icon/xiaozhi_logo.png" alt="" />
            <span>智能助手-小智</span> -->
            <!-- <img
              class="drag-box"
              src="../assets/icon/xiaozhi_logo2.png"
              alt=""
            /> -->
            <div class="drag-box xiaozhi-logo"></div>
            <span class="drag-box">小智AI</span>
          </div>
          <!-- <i class="el-icon-close" @click="closeRobot"></i> -->
        </div>

        <div
          class="content scroll"
          :style="{ height: robotHeight + screenY + 'px' }"
          id="robot-content-box"
          ref="scrollDiv"
        >
          <div class="xiaozhi-tips">
            你好，我是你的学习助手“小智”
            ，我可以为你解答此教材相关的内容，如章节摘要、段意总结、习题解析等，试试在下方输入问题吧
          </div>
          <div v-for="(item, index) in list" :key="item.id">
            <div
              class="timer"
              v-show="item.direction === 'right' || item.id == 'left_777'"
            >
              {{ item.time }}
            </div>
            <div
              v-show="item.direction === 'left'"
              class="item"
              :class="item.direction"
              :id="'robot-content-' + index"
            >
              <!-- <div class="cover">
                <img src="../assets/icon/xiaozhi_logo.png" alt="" />
              </div> -->

              <div class="text">
                {{ item.content }}
                <!-- {{
                  index === list.length - 1
                    ? item.content.slice(0, textIndex) +
                      (!item.loading && item.content.length > textIndex
                        ? "_"
                        : "")
                    : item.content
                }} -->

                <div v-show="item.videoUrl">
                  下面“小智”还为您推荐视频
                  <video
                    v-if="item.videoUrl"
                    width="100%"
                    style="margin: 14px 0 0 0"
                    controls
                    controlslist="nodownload"
                  >
                    <source :src="item.videoUrl" type="video/mp4" />
                  </video>
                </div>
                <!-- <img
                  v-show="item.loading"
                  src="../assets/icon/loading_icon.gif"
                  alt=""
                /> -->
                <div v-show="item.loading" style="line-height: 24px">
                  正在生成. . .
                </div>
                <span v-show="!item.loadingCompleted"></span>
              </div>
              <!-- 删除刷新按钮 -->
              <div class="operating" v-show="item.loadingCompleted">
                <div class="delete" @click="removalMessage(item, index)"></div>
                <div
                  class="refresh"
                  v-show="item.id != 'left_777'"
                  @click="refreshMessage(item, index)"
                ></div>
              </div>
            </div>
            <div
              v-show="item.direction === 'right'"
              class="item"
              :class="item.direction"
            >
              <!-- 删除按钮 -->
              <div class="operating">
                <div class="delete" @click="removalMessage(item, index)"></div>
              </div>
              <div class="text">
                {{ item.content }}
              </div>
              <!-- <div class="cover"></div> -->
            </div>
          </div>
        </div>

        <!--  -->
        <div
          class="download-dom"
          :style="{
            width: robotWidth + screenX + 'px',
          }"
        >
          <div class="content" ref="downloadDom">
            <div v-for="item in list" :key="item.id">
              <div
                v-show="item.direction === 'left'"
                class="item"
                :class="item.direction"
              >
                <!-- <div class="cover">
                <img src="../assets/icon/xiaozhi_logo.png" alt="" />
              </div> -->

                <div class="text">
                  {{ item.content }}
                  <!-- {{
                  index === list.length - 1
                    ? item.content.slice(0, textIndex) +
                      (!item.loading && item.content.length > textIndex
                        ? "_"
                        : "")
                    : item.content
                }} -->
                  <div v-show="item.videoUrl">
                    下面“小智”还为您推荐视频
                    <video
                      v-if="item.videoUrl"
                      width="100%"
                      style="margin: 14px 0 0 0"
                      controls
                      controlslist="nodownload"
                    >
                      <source :src="item.videoUrl" type="video/mp4" />
                    </video>
                  </div>
                  <!-- <img
                    v-show="item.loading"
                    src="../assets/icon/loading_icon.gif"
                    alt=""
                  /> -->
                  <div v-show="item.loading" style="line-height: 24px">
                    正在生成. . .
                  </div>
                  <span v-show="!item.loadingCompleted"></span>
                </div>
              </div>
              <div
                v-show="item.direction === 'right'"
                class="item"
                :class="item.direction"
              >
                <div class="text">
                  {{ item.content }}
                </div>
                <!-- <div class="cover"></div> -->
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="Progress-bar ">
          <div>
            正在生成...
            <span ></span>
          </div>
        </div> -->
        <!--  -->
        <div class="input-box">
          <div
            class="download"
            title="导出内容"
            @click="clickGeneratePicture()"
          ></div>
          <div class="input-right">
            <div
              class="input-content"
              contenteditable="true"
              placeholder="请输入问题描述"
              ref="Input"
              @keydown="handlePushKeyword($event)"
            ></div>
            <div class="sending" @click="sending($refs.Input.innerText)"></div>
          </div>
        </div>
        <div
          class="point point-top"
          @mousedown="mousedown($event, 'Y', 'top')"
        ></div>
        <div
          class="point point-left"
          @mousedown="mousedown($event, 'X', 'left')"
        ></div>
        <div
          class="point point-right"
          @mousedown="mousedown($event, 'X', 'right')"
        ></div>
        <div
          class="point point-bottom"
          @mousedown="mousedown($event, 'Y', 'bottom')"
        ></div>
      </div>
    </transition>
    <div
      v-show="!robotShwo"
      class="elfin-box"
      :class="elfinStatic ? 'elfin-gif' : ''"
      v-drag:{top:false,left:false}="{ top: true, left: true }"
      @mousedown="moveStart"
      @click.prevent="elfinClick"
    >
      <!-- <div class="dialog-box">Hi，快来一起学习吧</div> -->
      <transition name="Fade">
        <div class="dialog-box" v-show="elfinStatic">
          <span
            v-for="(item, index) in correct"
            :key="index"
            :style="{ 'animation-delay': 0.2 + index / correct.length + 's' }"
            >{{ item }}</span
          >
        </div>
      </transition>
    </div>
    <a id="downimg" href="" style="display: none"></a>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
export default {
  name: "robot",
  props: {
    bookName: {
      type: String,
      default: "",
    },
    goodsId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      list: [],
      robotShwo: false,
      timer: 0,
      textIndex: 1,
      Interval: null,
      robotWidth: 362, //400
      robotHeight: 500, //600
      left: 0,
      current: 0,
      screenX: 0,
      screenY: 0,
      correct: ["Hi", "，", "快", "来", "一", "起", "学", "习", "吧", "!"],
      elfinStatic: true,
      exportStatic: false,
      timeout: null,
    };
  },

  mounted() {
    this.robotHeight = window.innerHeight - 300;

    // calc((100% - 220px) / 2)
    this.left = (document.documentElement.clientWidth - 220) / 2 + "px";
    setTimeout(() => {
      this.elfinStatic = false;
    }, 5000);
  },

  methods: {
    mousedown(event, axial, direction) {
      this.current = axial == "X" ? event.screenX : event.screenY;
      let top = Number(this.$refs.robotView.style.top.split("px")[0]);
      let left = Number(this.$refs.robotView.style.left.split("px")[0]);
      document.onmousemove = (e) => {
        if (direction == "right") {
          if (
            e.screenX - this.current < 0 &&
            this.robotWidth + this.screenX > 300
          ) {
            this.screenX = e.screenX - this.current;
          } else if (
            e.screenX - this.current > 0 &&
            this.robotWidth + this.screenX < 1000
          ) {
            this.screenX = e.screenX - this.current;
          }
        } else if (direction == "bottom") {
          if (
            e.screenY - this.current < 0 &&
            this.robotHeight + this.screenY > 500
          ) {
            this.screenY = e.screenY - this.current;
          } else if (
            e.screenY - this.current > 0 &&
            this.robotHeight + this.screenY <
              document.documentElement.clientHeight - 140
          ) {
            this.screenY = e.screenY - this.current;
          }
        } else if (direction == "top") {
          if (
            this.current - e.screenY < 0 &&
            this.robotHeight + this.screenY > 500
          ) {
            this.screenY = this.current - e.screenY;
          } else if (
            this.current - e.screenY > 0 &&
            this.robotHeight + this.screenY <
              document.documentElement.clientHeight - 140 &&
            top - this.screenY > 0
          ) {
            this.screenY = this.current - e.screenY;
          }
          this.$refs.robotView.style.top = top - this.screenY + "px";
        } else if (direction == "left") {
          if (
            this.current - e.screenX < 0 &&
            this.robotWidth + this.screenX > 300
          ) {
            this.screenX = this.current - e.screenX;
          } else if (
            this.current - e.screenX > 0 &&
            this.robotWidth + this.screenX < 1000
          ) {
            this.screenX = this.current - e.screenX;
          }
          this.$refs.robotView.style.left = left - this.screenX + "px";
        }
      };
      document.onmouseup = (e) => {
        this.robotWidth += this.screenX;
        this.robotHeight += this.screenY;
        this.screenX = 0;
        this.screenY = 0;
        document.onmousemove = null;
      };
    },
    //   发送
    sending(Text) {
      if (Text.replace(/\s+/g, "") != "") {
        let rightData = {
          id: "right_" + new Date().getTime(),
          direction: "right",
          content: Text.replace(/\s+/g, ""),
          type: "text",
          loading: false,
          time: this.getTime(),
          videoUrl: "",
          loadingCompleted: true,
        };
        this.list.push(rightData);
        // 发送消息是创建一条内为空的回答
        let leftData = {
          id: "left_" + new Date().getTime(),
          direction: "left",
          content: "",
          type: "text",
          loading: true,
          time: this.getTime(),
          videoUrl: "",
          loadingCompleted: false,
        };
        this.list.push(leftData);
        // 获取回答内容
        this.loadData(Text.replace(/\s+/g, ""), this.list.length - 1);
        this.$refs.Input.innerHTML = "";

        setTimeout(() => {
          this.scrollToBottom();
        }, 200);
      }
    },

    // 获取当前时间
    getTime() {
      let date = new Date();
      let h = date.getHours();
      let m = date.getMinutes();
      return (h > 9 ? h : "0" + h) + ":" + (m > 9 ? m : "0" + m);
    },

    // 回车事件
    handlePushKeyword(event) {
      if (event.keyCode === 13) {
        event.preventDefault(); // 阻止浏览器默认换行操作
        this.sending(this.$refs.Input.innerText); // 发送文本
        return false;
      }
    },

    // 滚动内容
    scrollToBottom() {
      let Dom = this.$refs.scrollDiv;
      Dom.scrollTop = Dom.scrollHeight;
    },

    moveStart() {
      this.timer = new Date().getTime();
    },

    // 打开小智答疑窗口
    elfinClick() {
      let timer = new Date().getTime();
      if (timer - this.timer < 400) {
        this.robotShwo = true;
        if (this.list.length === 0) {
          //创建一条欢迎语
          let leftData = {
            id: "left_777",
            direction: "left",
            content: "您好，欢迎使用国开出版社＂小智＂达人~",
            type: "text",
            loading: false,
            time: this.getTime(),
            videoUrl: "",
            loadingCompleted: true,
          };
          // this.list.push(leftData);
          this.printer(18);
        }
      }
    },

    // 获取小智答疑答案
    async loadData(question, index) {
      let controller = new AbortController();
      let postData = {
        query: question,
        book: this.bookName,
        stream: "True",
      };
      try {
        const response = await fetch(process.env.VUE_APP_roboturl, {
          method: "post",
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
          body: JSON.stringify(postData),
          signal: controller.signal,
        });
        const reader = response.body.getReader();
        let data = "";
        let videoUrl = "";
        let content = "";
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            // setLoading(false);
            break;
          }
          data += new TextDecoder().decode(value);
          if (data.indexOf("DONE") !== -1) {
            this.list[index].loadingCompleted = true;
          }
          content = "";
          // 数据更新时销毁加载完成计时器
          if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
          }
          let eaderStream = data.split("\r\n\r\n");
          eaderStream.map((item) => {
            if (item) {
              let textData = item.split("data:");

              textData.map((items) => {
                if (items && items.indexOf("{") !== -1) {
                  let text = JSON.parse(items);
                  if (text.content) {
                    content += text.content;
                  }
                } else if (items.indexOf(".mp4") !== -1) {
                  videoUrl = items.slice(1, items.length - 7);
                }
              });
            }
          });
          this.list[index].loading = false;
          this.list[index].content = content;
          this.list[index].type = "text";

          this.list[index].videoUrl = videoUrl;
          setTimeout(() => {
            // this.scrollToBottom();
            let itemDom = document.getElementById("robot-content-" + index);
            let Dom = this.$refs.scrollDiv;
            Dom.scrollTop = itemDom.offsetTop + itemDom.offsetHeight - 500;
            // console.log(DOM.offsetHeight);
            // console.log(DOM.offsetTop);
          }, 200);

          // 防止加载完成还显示加载中进度条，5s后默认关闭
          this.timeout = setTimeout(() => {
            this.list[index].loadingCompleted = true;
          }, 5000);
        }
      } catch {
        this.list[index].loading = false;
        this.list[index].loadingCompleted = true;
        this.list[index].content =
          "亲，我的知识库里无法找到答案，请您修改问题重新提问。";
        this.list[index].type = "text";
      }
    },

    closeRobot() {
      this.robotShwo = false;
      let videoList =
        document
          .getElementById("robot-content-box")
          .querySelectorAll("video") || [];
      videoList.forEach((i) => {
        i.pause();
      });
    },
    /**
     *
     */
    // 文字打印机
    printer(num) {
      this.textIndex = 1;
      this.Interval = setInterval(() => {
        this.textIndex++;
        setTimeout(() => {
          this.scrollToBottom();
        }, 200);
        if (this.textIndex > num) {
          clearInterval(this.Interval);
          this.Interval = null;
        }
      }, 50);
    },

    // 删除消息
    removalMessage(item, index) {
      this.list.splice(index, 1);
      console.log(item, index);
    },

    // 刷新消息
    refreshMessage(item, index) {
      this.list[index].loadingCompleted = false;
      this.list[index].loading = true;
      this.list[index].content = "";
      this.list[index].type = "";

      this.list[index].videoUrl = "";
      this.loadData(this.list[index - 1].content, index);
      console.log(item, index);
    },

    /**
     * 将页面指定节点内容转为图片
     * 1.拿到想要转换为图片的内容节点DOM；
     * 2.转换，拿到转换后的canvas
     * 3.转换为图片
     */
    clickGeneratePicture() {
      const loading = this.$loading({
        lock: true,
        text: "正在生成图片",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.exportStatic = true;
      html2canvas(this.$refs.downloadDom, {
        allowTaint: true, // 允许渲染跨域图片
        scale: window.devicePixelRatio * 2, // 增加清晰度
        useCORS: true, // 允许跨域
      }).then((canvas) => {
        this.exportStatic = false;
        // 转成图片，生成图片地址
        let imgUrl = canvas.toDataURL("image/png");
        document.querySelector("#downimg").href = imgUrl;
        document.querySelector("#downimg").download =
          new Date().getTime() + ".png";
        document.querySelector("#downimg").click();
        loading.close();
      });
    },
  },
};
</script>


<style scoped lang="scss">
.robot-content {
  position: fixed;
  left: 0;
  top: 0;
  width: 1920px;
  height: 100vh;
  z-index: 999;
  // pointer-events: fill;

  div {
    box-sizing: border-box;
  }
  .robot-view {
    user-select: inherit;
    // position: fixed;
    pointer-events: fill;
    position: absolute;
    // top: 66px;
    // left: calc((100% - 220px) / 2);
    z-index: 9999;
    // width: 400px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #f2f2f2;
    box-shadow: 1px 6px 8px #cccccc;
    background-color: #fff;
    .title-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 50px;
      padding: 0 16px;
      // height: 60px;
      background-image: linear-gradient(
        -75deg,
        rgba(252, 197, 192, 0.2) 0%,
        rgba(128, 212, 222, 0.2) 0%,
        rgba(3, 227, 251, 0.2) 0%,
        rgba(1, 97, 240, 0.2) 100%
      );
      .logo {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 40px;
        }
        .xiaozhi-logo {
          width: 40px;
          height: 28px;
          background-image: url("../assets/icon/xiaozhi_logo2.png");
          background-size: 100%;
          background-repeat: no-repeat;
        }
        span {
          padding-left: 14px;
          font-family: SourceHanSansCN-Medium;
          font-size: 16px;
          font-weight: 600;
          font-stretch: normal;
          line-height: 50px;
          letter-spacing: 0px;
          // color: #323131;
          color: #0d27c6;
        }
      }
      .el-icon-close {
        font-size: 20px;
        font-weight: 800;
        color: #999;
        cursor: pointer;
      }
    }

    .xiaozhi-tips {
      width: 100%;
      height: 85px;
      background-image: linear-gradient(
        180deg,
        rgba(252, 197, 192, 0.1) 0%,
        rgba(128, 212, 222, 0.1) 0%,
        rgba(3, 227, 251, 0.1) 0%,
        transparent 100%
      );
      font-family: SourceHanSansCN-Light;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 24px;
      letter-spacing: 0px;
      color: #405ad1;
      padding: 15px;
      box-sizing: border-box;
      text-align: left;
      padding-bottom: 0;
      position: absolute;
      top: 0;
      left: 0;
    }
    .scroll {
      overflow-y: scroll;
    }
    .content {
      width: 100%;
      // height: calc(100vh - 260px);
      padding: 8px;
      // background: #f7fcff;
      background: #fff;
      position: relative;
      padding-top: 85px;

      .timer {
        width: 100%;
        padding: 8px 0;
        text-align: center;
        font-family: SourceHanSansCN-Light;
        font-size: 14px;
        letter-spacing: 0px;
        color: #848484;
      }

      .item {
        display: flex;
        margin-bottom: 16px;
        .cover {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          background: #fff;
          overflow: hidden;
          background-image: url("../assets/images/evaluate_avatar.png");
          background-size: 100% 100%;
          img {
            width: 38px;
            height: 38px;
          }
        }
        .text {
          position: relative;
          z-index: 10;
          // max-width: calc(100% - 80px);
          max-width: calc(100% - 34px);
          padding: 8px 10px;
          font-size: 15px;
          word-wrap: break-word;
          color: #555;

          span {
            width: calc(100% - 5px);
            height: 4px;
            // background-image: linear-gradient(90deg, #2495ff 0%, #03e3fb 24%, #c557f8 57%, #0161f0 100%);
            position: absolute;
            left: 3px;
            bottom: 0px;
            border-radius: 0 0 8px 8px;
            z-index: 0;

            animation: myAnimation 0.8s linear infinite;
          }
        }
        .operating {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding-left: 6px;
          .delete {
            margin-top: 8px;
            width: 14px;
            height: 20px;
            background-image: url(../assets/icon/delete_01.png);
            background-size: 100%;
            background-repeat: no-repeat;
            cursor: pointer;
          }
          .refresh {
            margin-top: 8px;
            width: 14px;
            height: 20px;
            background-image: url(../assets/icon/refresh_01.png);
            background-size: 100%;
            background-repeat: no-repeat;
            cursor: pointer;
          }
        }
      }
      .left {
        .text {
          margin-left: 8px;
          // border-radius: 2px 8px 8px 8px;
          border-radius: 6px;
          // background: #e6f8ff;
          background-color: #f4f4f4;
          border-radius: 0px 15px 15px 15px;
          border: solid 1px #e5e5e5;
          color: #484848;
        }
        // .text::after {
        //   content: "◀";
        //   position: absolute;
        //   top: calc(50% - 12px);
        //   left: -8px;
        //   font-size: 18px;
        //   color: #e6f8ff;
        //   z-index: 1;
        // }
      }
      .right {
        justify-content: flex-end;
        .text {
          margin-right: 8px;
          border-radius: 6px;
          // background: #3482fa;
          // color: #ffffff;
          background-color: rgba(187, 232, 255, 0.3);
          border-radius: 15px 0px 15px 15px;
          border: solid 1px #bbe8ff;
          color: #000000;
        }
        // .text::after {
        //   content: "◀";
        //   position: absolute;
        //   top: calc(50% - 12px);
        //   right: -8px;
        //   font-size: 18px;
        //   color: #3482fa;
        //   transform: rotate(180deg);
        //   z-index: 1;
        // }
        .operating {
          padding: 0 6px 0 0;
        }
      }
    }
    @keyframes myAnimation {
      0% {
        background-image: linear-gradient(
          90deg,
          #2495ff 0%,
          #c557f8 24%,
          #03e3fb 57%,
          #0161f0 100%
        );
      }
      25% {
        background-image: linear-gradient(
          90deg,
          #0161f0 0%,
          #2495ff 24%,
          #c557f8 57%,
          #03e3fb 100%
        );
      }
      50% {
        background-image: linear-gradient(
          90deg,
          #03e3fb 0%,
          #0161f0 24%,
          #2495ff 57%,
          #c557f8 100%
        );
      }
      75% {
        background-image: linear-gradient(
          90deg,
          #c557f8 0%,
          #03e3fb 24%,
          #0161f0 57%,
          #2495ff 100%
        );
      }
      100% {
        background-image: linear-gradient(
          90deg,
          #2495ff 0%,
          #c557f8 24%,
          #03e3fb 57%,
          #0161f0 100%
        );
      }
    }
    .Progress-bar {
      width: 90%;
      height: 60px;
      background-color: #f4f4f4;
      border-radius: 0px 15px 10px 10px;
      border: solid 1px #e5e5e5;
      position: absolute;
      bottom: 90px;
      left: 50%;
      transform: translate(-50%);
      line-height: 60px;
      z-index: 99;

      > div {
        width: 100%;
        position: relative;
        padding-left: 20px;
        span {
          width: calc(100% - 5px);
          height: 8px;
          // background-image: linear-gradient(90deg, #2495ff 0%, #03e3fb 24%, #c557f8 57%, #0161f0 100%);
          position: absolute;
          left: 3px;
          bottom: -3px;
          border-radius: 0 0 8px 8px;
          z-index: 0;

          animation: myAnimation 0.8s linear infinite;
        }
      }
    }
    .input-box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 14px;
      // background: #f4f7ff;
      // background: #ffffff;
      background-image: linear-gradient(
        180deg,
        transparent 0%,
        rgba(3, 227, 251, 0.1) 100%
      );
      // border-top: solid 1px #d2d2d2;
      position: relative;

      &::before {
        content: "";
        width: 90%;
        height: 1px;
        background-color: #bbe8ff;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%);
      }

      .download {
        width: 20px;
        height: 20px;
        background-image: url(../assets/icon/download.png);
        background-size: 100%;
        background-repeat: no-repeat;
        cursor: pointer;
      }

      .input-right {
        width: calc(100% - 40px);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background-color: #ffffff;
        border-radius: 7px;
        border: solid 1px #bbe8ff;
        padding-right: 10px;
      }
      .input-content {
        // width: calc(100% - 76px);
        width: 100%;
        outline: none;
        // min-height: 50px;
        // max-height: 70px;
        max-height: 50px;
        overflow-y: scroll;
        padding: 6px 14px;
        font-size: 16px;
        color: #333;
        font-family: "微软雅黑";
        background-color: #ffffff;
        border-radius: 6px;
        // border: solid 1px #d2d2d2;
      }
      .input-content:empty::before {
        content: attr(placeholder);
        color: #777;
      }

      .sending {
        display: flex;
        justify-content: center;
        align-items: center;
        // margin-top: 10px;
        // width: 34px;
        // height: 34px;
        width: 16px;
        height: 20px;
        // background-color: #159fff;
        border-radius: 10px;
        // background-image: url("../assets/icon/sending.png");
        background-image: url("../assets/icon/sending2.png");
        background-size: 100% 100%;
        cursor: pointer;
        font-family: SourceHanSansCN-Light;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
        margin-left: 10px;
      }
      .sending:hover {
        opacity: 0.7;
      }
    }
    .point {
      // background: red;
    }
    .point-top {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 6px;
      cursor: n-resize;
    }
    .point-bottom {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 6px;
      cursor: n-resize;
    }
    .point-left {
      position: absolute;
      top: 0;
      left: 0;
      width: 6px;
      height: 100%;
      cursor: e-resize;
    }
    .point-right {
      position: absolute;
      top: 0;
      right: 0;
      width: 6px;
      height: 100%;
      cursor: e-resize;
    }
  }

  .elfin-box {
    pointer-events: fill;
    position: fixed;
    bottom: 50px;
    right: 46px;
    z-index: 9999;
    width: 120px;
    height: 120px;
    cursor: pointer;
    // background-color: #fff;
    // border: 3px solid #333;
    background-image: url("../assets/images/elfin.png");
    background-size: 100%;
    background-repeat: no-repeat;
    // transform: rotate(10edg);
    animation: turn 2s linear infinite;
    .dialog-box {
      position: absolute;
      padding: 28px 26px 10px 26px;
      top: -62px;
      left: -96px;
      width: 140px;
      font-size: 14px;
      height: 90px;
      background-image: url("../assets/images/dialog_box.png");
      background-size: 100%;
      background-repeat: no-repeat;
      box-sizing: border-box;
      overflow: hidden;
      span {
        animation: bounce 0.5s 1 forwards;
        display: inline-block;
        transform: translate3d(0, -70px, 0);
      }
    }

    @keyframes bounce {
      0% {
        transform: translate3d(0, -70px, 0);
      }

      100% {
        transform: translate3d(0, 0, 0);
      }
    }
  }

  .elfin-gif {
    background-image: url("../assets/images/elfin.gif");
  }
}
@keyframes turn {
  0% {
    transform: translateY(0);
  }

  20% {
    transform: translateY(-2px);
  }

  40% {
    transform: translateY(-4px);
  }

  60% {
    transform: translateY(-2px);
  }

  80% {
    transform: translateY(0px);
  }

  100% {
    transform: translateY(0px);
  }
}

.Fade-enter,
.Fade-leave-to {
  opacity: 0;
}
.Fade-enter-to,
.Fade-leave {
  opacity: 1;
}

.Fade-enter-active,
.Fade-leave-active {
  transition: all 0.6s;
}

.download-dom {
  position: fixed;
  top: 0;
  left: 0;
  height: 0px;
  overflow-y: scroll;
}
</style>